// extracted by mini-css-extract-plugin
export default {"Container":"spinner_Container__O3hLD"};